
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class JpmSecClassOverrideDialog extends SiteEntityDialog<JpmSecClassOverrideRow, any> {
        protected getFormKey() { return JpmSecClassOverrideForm.formKey; }
        protected getIdProperty() { return JpmSecClassOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return JpmSecClassOverrideRow.localTextPrefix; }
        protected getNameProperty() { return JpmSecClassOverrideRow.nameProperty; }
        protected getService() { return JpmSecClassOverrideService.baseUrl; }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "clone-button"), 1);
            return buttons;
        }

        protected form = new JpmSecClassOverrideForm(this.idPrefix);

    }
}